import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Paper,
  Chip
} from '@mui/material';
import { useData } from '../../context/DataContext';
import { Link as RouterLink } from 'react-router-dom';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import HealingIcon from '@mui/icons-material/Healing';
import BiotechIcon from '@mui/icons-material/Biotech';
import { getServiceImageUrl, getServiceRoute } from '../../utils/serviceImages';
import useServicePageCms from '../../hooks/useServicePageCms';
import { useMarkPageReadyWithoutHero } from '../../context/PageReadyContext';
import ServicePageBody from './ServicePageBody';

const Services = () => {
  useMarkPageReadyWithoutHero();
  const { content } = useServicePageCms('services');
  const { state } = useData();
  const { services } = state;

  const getServiceIcon = (iconName) => {
    switch (iconName) {
      case 'emergency': return <LocalHospitalIcon />;
      case 'medical_services': return <MedicalServicesIcon />;
      case 'healing': return <HealingIcon />;
      case 'biotech': return <BiotechIcon />;
      default: return <LocalHospitalIcon />;
    }
  };

  return (
    <Box>
      {/* Hero Section */}
      <Paper sx={{
        background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
        color: 'white',
        py: 8,
        textAlign: 'center'
      }}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            {content.title}
          </Typography>
          <Typography variant="h5" sx={{ opacity: 0.9 }}>
            {content.subtitle}
          </Typography>
        </Container>
      </Paper>

      {/* Services Grid */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom textAlign="center" sx={{ mb: 6 }}>
          {content.introTitle}
        </Typography>
        <Grid container spacing={4}>
          {services.filter((service) => service.isActive !== false && service.name).map((service) => (
            <Grid item xs={12} sm={6} md={6} key={service.id}>
              <Card sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                '&:hover': { 
                  transform: 'translateY(-8px)', 
                  transition: 'transform 0.3s ease',
                  boxShadow: 6
                }
              }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={getServiceImageUrl(service)}
                  alt={service.name}
                />
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box sx={{ color: 'primary.main', mr: 1 }}>
                      {getServiceIcon(service.icon)}
                    </Box>
                    <Typography variant="h6" component="h3">
                      {service.name}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                    {service.description}
                  </Typography>
                  <Chip 
                    label="Learn More" 
                    color="primary" 
                    variant="outlined" 
                    component={RouterLink}
                    to={getServiceRoute(service)}
                    clickable
                    sx={{ 
                      mt: 2, 
                      alignSelf: 'flex-start',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: 2
                      },
                      transition: 'all 0.2s ease'
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <ServicePageBody content={content} inContainer={false} greyBoxesBackground />
    </Box>
  );
};

export default Services; 